export const engagementAppGroupIdEmailTemplatesIdPreviewThumbnail =
  "/engagement/:app_group_id/email_templates/:id/preview_thumbnail";
